import React, { useState } from 'react';
import { Button, ExternalButton } from '../ButtonElements';

import BackgroundImage from '../../images/background.jpg'
import {
  HeroContainer,
  HeroContent,
  HeroH1,
  HeroP,
  HeroRule,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight
} from './HeroElements';

function HeroSection() {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };
  return (
    <HeroContainer id='home' style={{ backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.12), rgba(13, 24, 16, 0.42) ), url(${BackgroundImage})` }}>
      <HeroContent>
        <HeroH1>Where Golfing<br />Meets Hunting</HeroH1>
        <HeroRule />
        <HeroP>
          From Greens to Game Trails
        </HeroP>
        <HeroBtnWrapper>
          <Button
            to='/shop'
            smooth='true'
            duration={500}
            spy='true'
            exact='true'
            offset={-80}
            primary='true'
            dark='true'
            onMouseEnter={onHover}
            onMouseLeave={onHover}
          >
            Shop Now {hover ? <ArrowForward /> : <ArrowRight />}
          </Button>
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
}

export default HeroSection;